import { render, staticRenderFns } from "./HeaderInlineMenu.vue?vue&type=template&id=bc891a84"
import script from "./HeaderInlineMenu.vue?vue&type=script&lang=js"
export * from "./HeaderInlineMenu.vue?vue&type=script&lang=js"
import style0 from "./HeaderInlineMenu.vue?vue&type=style&index=0&id=bc891a84&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLink: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/22072026_100728/resources/assets/marketplace/components/BaseLink.vue').default})
